import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import type { Tag } from '@/api/typings/tags';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterByTagDropdown',
  props: {
    value: null,
    tags: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', value: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: number[];
    tags: Tag[];
};





const localSelectedIds = ref<number[]>([...(props.value ?? [])]);

const sameIds = (a: number[], b: number[]) => {
    if (a.length !== b.length) {
        return false;
    }
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((id, index) => id === sortedB[index]);
};

// Only re-sync from the prop when it actually differs from local state — otherwise the
// prop echo (parent re-emits the same ids back down) and this watcher's own emit would
// keep re-triggering each other in an infinite loop.
watch(
    () => props.value,
    (value) => {
        const incoming = value ?? [];
        if (!sameIds(incoming, localSelectedIds.value)) {
            localSelectedIds.value = [...incoming];
        }
    }
);

watch(localSelectedIds, (value) => {
    emit('change', [...value]);
});

const clearFilters = () => {
    localSelectedIds.value = [];
};

return { __sfc: true,props, emit, localSelectedIds, sameIds, clearFilters }
}

})